export type ServiceWorkerLike = {
  state?: ServiceWorkerState;
} | null | undefined;

export type ServiceWorkerRegistrationLike = {
  waiting?: ServiceWorkerLike;
} | null | undefined;

export function hasActionableWaitingServiceWorker(
  registration: ServiceWorkerRegistrationLike,
  controller: ServiceWorkerLike,
): boolean {
  const waiting = registration?.waiting;

  if (!waiting || !controller) return false;
  if (waiting === controller) return false;
  if (waiting.state === 'redundant') return false;

  return true;
}
